module.exports = __webpack_public_path__ + "img/Logo_Digiasia_White1.c671c74f.png";